import { createSimpleStore } from "@expert/state-utils";

import { env } from "@/config";

import { getBusinessToday } from "../data/businessDay";

interface MorningPaperState {
    lastDismissedDate: string | null;
}

interface MorningPaperActions {
    dismissForToday: () => void;
    reset: () => void;
}

export type MorningPaperStore = MorningPaperState & MorningPaperActions;

const defaultState: MorningPaperState = {
    lastDismissedDate: null,
};

export const useMorningPaperStore = createSimpleStore<MorningPaperStore>({
    devtools: { store: "morning-paper", name: "workspace/morning-paper", isProd: env.isProdMode },
    persist: {
        name: "morning-paper-store",
        partialize: (state) => ({ lastDismissedDate: state.lastDismissedDate }),
    },
})((set) => ({
    ...defaultState,

    dismissForToday: () => set({ lastDismissedDate: getBusinessToday() }, false, "dismissForToday"),
    reset: () => set(defaultState, false, "reset"),
}));
